import * as z from 'zod'
import { RentalContactCreationRequest } from '~/shared/api'

export const formSchema = RentalContactCreationRequest.schema.pick({
  rentalServices: true,
})

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<TypeFormSchema, 'rentalServices'> & {
  rentalServices: Record<string, boolean> | string[]
}
